// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form{
  display:grid;
}
.formSection {
  display: grid;
  /*border:1px solid black;*/
  /*padding:10px;*/
}
.buttonbar{
  display:flex;
}
.center {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    display: table;
    width: 20%;
    background-color: lightgray;
}
.error {
  color:red;
}

.mdc-button {
    background-color: var(--primary-color);
    color: white;
}

.mat-icon {
 color:   var(--primary-color);
}

.login {
    font-size: x-large;
    color: rgb(88, 88, 88);
    text-align: center;
}

.login-icon {
    font-size: 100px;
    width: 100%;
    height: 100%;
    text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/app/components/controls/login/login.control.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,0BAA0B;EAC1B,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,+BAA+B;IAC/B,cAAc;IACd,UAAU;IACV,2BAA2B;AAC/B;AACA;EACE,SAAS;AACX;;AAEA;IACI,sCAAsC;IACtC,YAAY;AAChB;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB","sourcesContent":[".form{\n  display:grid;\n}\n.formSection {\n  display: grid;\n  /*border:1px solid black;*/\n  /*padding:10px;*/\n}\n.buttonbar{\n  display:flex;\n}\n.center {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%,-50%);\n    display: table;\n    width: 20%;\n    background-color: lightgray;\n}\n.error {\n  color:red;\n}\n\n.mdc-button {\n    background-color: var(--primary-color);\n    color: white;\n}\n\n.mat-icon {\n color:   var(--primary-color);\n}\n\n.login {\n    font-size: x-large;\n    color: rgb(88, 88, 88);\n    text-align: center;\n}\n\n.login-icon {\n    font-size: 100px;\n    width: 100%;\n    height: 100%;\n    text-align: center;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
